// ─────────────────────────────────────────────────────────────────────────────
// components/ui.jsx
// Componenti UI condivisi tra tutte le sezioni dell'app.
// ─────────────────────────────────────────────────────────────────────────────
import { View, Text, StyleSheet } from 'react-native'
import { fonts } from '../lib/theme'
import { useThemeColors } from '../lib/useThemeColors'

// ─── Card ─────────────────────────────────────────────────────────────
export function Card({ children, style }) {
  const tc = useThemeColors()
  return (
    <View style={[styles.card, { backgroundColor: tc.bgCard, borderColor: tc.border }, style]}>
      {children}
    </View>
  )
}

// ─── SectionLabel ─────────────────────────────────────────────────────
export function SectionLabel({ children, mb = 0 }) {
  const tc = useThemeColors()
  return (
    <View style={[styles.sectionLabel, mb > 0 && { marginBottom: mb }]}>
      <View style={[styles.sectionBar, { backgroundColor: tc.rosa }]} />
      <Text style={[styles.sectionText, { color: tc.text }]}>{children}</Text>
    </View>
  )
}

// ─── SubHeader ────────────────────────────────────────────────────────
// icon può essere una stringa (emoji) o un componente JSX (icona vettoriale)
export function SubHeader({ icon, children }) {
  const tc = useThemeColors()
  const isJSX = icon && typeof icon !== 'string'
  return (
    <View style={styles.subHeader}>
      {isJSX
        ? <View style={styles.subHeaderIconWrap}>{icon}</View>
        : <Text style={styles.subHeaderIcon}>{icon}</Text>
      }
      <Text style={[styles.subHeaderText, { color: tc.text }]}>{children}</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  card: { borderRadius: 14, borderWidth: 1, padding: 16, marginBottom: 16 },
  sectionLabel: { flexDirection: 'row', alignItems: 'center', gap: 10 },
  sectionBar: { width: 3, height: 18, borderRadius: 2 },
  sectionText: { fontFamily: fonts.condensedBold, fontSize: 17, textTransform: 'uppercase', letterSpacing: 0.5 },
  subHeader: { flexDirection: 'row', alignItems: 'center', gap: 8, marginBottom: 12 },
  subHeaderIcon: { fontSize: 16 },
  subHeaderIconWrap: { width: 20, alignItems: 'center' },
  subHeaderText: { fontFamily: fonts.condensedBold, fontSize: 15, textTransform: 'uppercase', letterSpacing: 0.5 },
})